import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AntavoService } from 'projects/app-default/src/app/module/antavo/antavo.service';
import { NAntavo } from 'projects/app-default/src/app/module/antavo/antavo.interface';

@Component({
    selector: 'pwa-mission',
    templateUrl: './pwa-mission.html',
    styleUrls: ['./pwa-mission.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, RouterLink]
})
export class PwaMissionComponent {
    @Input({ required: true })
    mission!: NAntavo.IChallenge;

    private antavoService = inject(AntavoService);

    get isCompleted(): boolean {
        return this.antavoService.isMissionCompleted(this.mission);
    }

    get progressPercentage(): number {
        return this.antavoService.getMissionProgressPercentage(this.mission);
    }

    get detailsLink(): string {
        return `/account/my-missions/${this.mission.id}`;
    }
}
